module.exports = __webpack_public_path__ + "img/HU10326556.a7213c42.png";